import React from "react";
import styles from "./PageHero.module.scss";
import { Breadcrumb } from "antd";
import { Link, withRouter, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import en from "../../localization/en";
import ar from "../../localization/ar";
import { css } from "@emotion/css";
function PageHero({ title, link }) {
  const { currentLang } = useSelector((state) => state?.user);
  const t = currentLang === "ar" ? ar : en;

    const container = css`
      margin-left: auto !important;
      margin-right: auto !important;
      width: 100%;
  
      @include mq("xxl", min) {
        max-width: 1427px;
      }
      @include mq("xxl") {
        max-width: 1127px;
      }
      @include mq("xl") {
        max-width: 933px;
      }
      @include mq("lg") {
        max-width: 723px;
      }
      @include mq("md") {
        max-width: 100vw;
        padding: 0 1.5rem;
      }
      `;


  const colorWhite1 = "#fff"; // Or whatever color you prefer

  const breadcrumb = css`
    font-size: 2rem;
    font-weight: 500;
    text-transform: capitalize;
    letter-spacing: 0.16px;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    .breadcrumb-to a {
      color: ${colorWhite1};
      white-space: nowrap;
    }
    .breadcrumb-current {
      color: ${colorWhite1};
      font-weight: 700;
      white-space: nowrap;
    }
    .ant-breadcrumb-separator {
      color: ${colorWhite1} !important;
    }
  `;

  return (
    <div className={styles.page_hero_wrapper + "  page_hero_wrapper"}>
      <div className={container}>
        <div className={styles.page_hero_content}>
          <h1>{title}</h1>
          <Breadcrumb className={breadcrumb} separator=">">
            <Breadcrumb.Item className="breadcrumb-to">
              <Link to="/">{t.home}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item className="breadcrumb-current">
              {link || title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
}

export default PageHero;
